import React from "react";
import { ToFirstCapital } from "../../Utils/helpers";
import "./viewAdsBannerModal.css";

const ViewAdBannerModal = ({ visible, record, onClose }) => {
    if (!visible) return null;

    return (
        <div className="vab-overlay" onClick={onClose}>
            <div className="vab-modal" onClick={(e) => e.stopPropagation()}>

                <div className="vab-modal-header">
                    <div className="vab-modal-header-left">
                        <div className="vab-modal-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="2" y="3" width="20" height="14" rx="2" />
                                <path d="M8 21h8M12 17v4" />
                            </svg>
                        </div>
                        <div>
                            <h2 className="vab-modal-title">Ad / Banner Details</h2>
                            <p className="vab-modal-subtitle">Full information about this record</p>
                        </div>
                    </div>
                    <button className="vab-close-btn" onClick={onClose} type="button">
                        <span className="vab-close-x">×</span>
                    </button>
                </div>

                {record ? (
                    <div className="vab-modal-body">

                        {record.cover_photo && (
                            <div className="vab-media-wrap">
                                {["mp4", "avi"].includes(record.cover_photo.split(".").pop()?.toLowerCase()) ? (
                                    <video
                                        className="vab-media"
                                        src={record.cover_photo}
                                        controls
                                    />
                                ) : (
                                    <img
                                        className="vab-media"
                                        src={record.cover_photo}
                                        alt="Banner"
                                    />
                                )}
                                <span className={`vab-type-chip vab-type-chip--${record.type}`}>
                                    {ToFirstCapital(record.type || "")}
                                </span>
                            </div>
                        )}

                        <div className="vab-info-grid">
                            <div className="vab-info-item vab-info-item--full">
                                <span className="vab-info-label">Title</span>
                                <span className="vab-info-value">{record.title || "—"}</span>
                            </div>

                            <div className="vab-info-item vab-info-item--full">
                                <span className="vab-info-label">Description</span>
                                <span className="vab-info-value vab-info-value--desc">{record.description || "—"}</span>
                            </div>

                            <div className="vab-info-item">
                                <span className="vab-info-label">Status</span>
                                <span className={`vab-status-pill vab-status-pill--${record.status?.toLowerCase()}`}>
                                    {ToFirstCapital(record.status || "")}
                                </span>
                            </div>

                            <div className="vab-info-item">
                                <span className="vab-info-label">Type</span>
                                <span className="vab-info-value">{ToFirstCapital(record.type || "")}</span>
                            </div>

                            <div className="vab-info-item">
                                <span className="vab-info-label">Start Date</span>
                                <span className="vab-info-value">
                                    {record.start_date ? new Date(record.start_date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"}
                                </span>
                            </div>

                            <div className="vab-info-item">
                                <span className="vab-info-label">End Date</span>
                                <span className="vab-info-value">
                                    {record.end_date ? new Date(record.end_date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"}
                                </span>
                            </div>

                            {record.external_link && (
                                <div className="vab-info-item vab-info-item--full">
                                    <span className="vab-info-label">External Link</span>
                                    <a
                                        className="vab-link"
                                        href={record.external_link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                            <polyline points="15 3 21 3 21 9" />
                                            <line x1="10" y1="14" x2="21" y2="3" />
                                        </svg>
                                        {record.external_link}
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="vab-empty">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <p>No data available</p>
                    </div>
                )}

                <div className="vab-modal-footer">
                    <button className="vab-btn vab-btn--close" onClick={onClose} type="button">
                        Close
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ViewAdBannerModal;